import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { string, func, arrayOf, shape, number, oneOf } from 'prop-types';
import Item from './item';
import { useMergeCssClasses } from '../../../../../Utils/utils';
import defaultClasses from './productList.module.css';

var ProductList = function ProductList(props) {
  var items = props.items,
      handleRemoveItem = props.handleRemoveItem,
      propClasses = props.classes,
      closeMiniCart = props.closeMiniCart,
      configurableThumbnailSource = props.configurableThumbnailSource,
      storeUrlSuffix = props.storeUrlSuffix;
  var classes = useMergeCssClasses(defaultClasses, propClasses);
  var cartItems = useMemo(function () {
    if (items) {
      return items.map(function (item) {
        return React.createElement(Item, _extends({
          key: item.uid
        }, item, {
          closeMiniCart: closeMiniCart,
          handleRemoveItem: handleRemoveItem,
          configurableThumbnailSource: configurableThumbnailSource,
          storeUrlSuffix: storeUrlSuffix
        }));
      });
    }
  }, [items, handleRemoveItem, closeMiniCart, configurableThumbnailSource, storeUrlSuffix]);
  return React.createElement("div", {
    className: classes.root
  }, cartItems);
};

export default ProductList;
ProductList.propTypes = {
  classes: shape({
    root: string
  }),
  items: arrayOf(shape({
    product: shape({
      name: string,
      thumbnail: shape({
        url: string
      })
    }),
    id: string,
    quantity: number,
    configurable_options: arrayOf(shape({
      label: string,
      value: string
    })),
    prices: shape({
      price: shape({
        value: number,
        currency: string
      })
    }),
    configured_variant: shape({
      thumbnail: shape({
        url: string
      })
    })
  })),
  configurableThumbnailSource: oneOf(['parent', 'itself']),
  handleRemoveItem: func
};